/**
 * @generated SignedSource<<a6afdff295845f0127dd06c570439a79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MATSalesRecordStatusEnum = "absent" | "contract_planned" | "contract_succeed" | "exclude" | "feature_show" | "follow_up_required" | "ongoing" | "pending" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MATSalesRecordStatusLabel_matSalesRecord$data = {
  readonly status: MATSalesRecordStatusEnum | null;
  readonly " $fragmentType": "MATSalesRecordStatusLabel_matSalesRecord";
};
export type MATSalesRecordStatusLabel_matSalesRecord$key = {
  readonly " $data"?: MATSalesRecordStatusLabel_matSalesRecord$data;
  readonly " $fragmentSpreads": FragmentRefs<"MATSalesRecordStatusLabel_matSalesRecord">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MATSalesRecordStatusLabel_matSalesRecord",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "MATSalesRecord",
  "abstractKey": null
};

(node as any).hash = "157574bca968bab55ad289e0af75a7da";

export default node;
